// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"QV-z","inlineTitle":"RV-z","sponsoredAdsWrapper":"SV-z","marketplaceRecosWrapper":"TV-z"};